/**
 * Trustpilot Widget Reinitialization for Scrolling Content
 * 
 * Problem: When scrolling-items component clones content, Trustpilot widgets
 * are duplicated but not reinitialized, showing as broken/old widgets.
 * 
 * Solution: Monitor for content changes and reinitialize all Trustpilot widgets.
 */

(function() {
  'use strict';
  
  console.log('[Trustpilot Reinit] Script loaded');
  
  // Check if Trustpilot is available
  function isTrustpilotAvailable() {
    return typeof window.Trustpilot !== 'undefined' && 
           typeof window.Trustpilot.loadFromElement === 'function';
  }
  
  /**
   * Reinitialize all Trustpilot widgets on the page
   */
  function reinitializeTrustpilotWidgets() {
    if (!isTrustpilotAvailable()) {
      console.log('[Trustpilot Reinit] Trustpilot API not yet available, will retry');
      return false;
    }
    
    const widgets = document.querySelectorAll('.trustpilot-widget');
    
    if (widgets.length === 0) {
      console.log('[Trustpilot Reinit] No widgets found');
      return true;
    }
    
    console.log('[Trustpilot Reinit] Reinitializing', widgets.length, 'widgets');
    
    widgets.forEach(function(widget, index) {
      try {
        // Trustpilot's loadFromElement method reinitializes a widget
        window.Trustpilot.loadFromElement(widget, true);
        console.log('[Trustpilot Reinit] Widget', index + 1, 'reinitialized');
      } catch (e) {
        console.warn('[Trustpilot Reinit] Error reinitializing widget', index + 1, ':', e);
      }
    });
    
    return true;
  }
  
  /**
   * Wait for Trustpilot API to be available, then reinitialize
   */
  function waitForTrustpilotAndReinit(attempt) {
    attempt = attempt || 1;
    var maxAttempts = 50; // Try for up to 5 seconds (50 * 100ms)
    
    if (reinitializeTrustpilotWidgets()) {
      console.log('[Trustpilot Reinit] Successfully reinitialized after', attempt, 'attempts');
      return;
    }
    
    if (attempt < maxAttempts) {
      setTimeout(function() {
        waitForTrustpilotAndReinit(attempt + 1);
      }, 100);
    } else {
      console.warn('[Trustpilot Reinit] Trustpilot API never became available after', maxAttempts, 'attempts');
    }
  }
  
  /**
   * Set up a MutationObserver to watch for scrolling-items content changes
   */
  function observeScrollingItems() {
    console.log('[Trustpilot Reinit] Setting up observers for scrolling content');
    
    // Find all scrolling-items-surface elements (where clones are added)
    var scrollingSurfaces = document.querySelectorAll('scrolling-items-surface');
    
    if (scrollingSurfaces.length === 0) {
      console.log('[Trustpilot Reinit] No scrolling surfaces found yet, will retry');
      return false;
    }
    
    console.log('[Trustpilot Reinit] Found', scrollingSurfaces.length, 'scrolling surfaces');
    
    scrollingSurfaces.forEach(function(surface) {
      // Check if this surface contains Trustpilot widgets
      if (!surface.querySelector('.trustpilot-widget')) {
        return; // Skip surfaces without Trustpilot widgets
      }
      
      console.log('[Trustpilot Reinit] Observing surface with Trustpilot widget');
      
      var observer = new MutationObserver(function(mutations) {
        var hasRelevantChanges = false;
        
        mutations.forEach(function(mutation) {
          // Check if nodes were added (cloning happened)
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              // Check if added node contains Trustpilot widget
              if (node.nodeType === 1 && 
                  (node.classList.contains('trustpilot-widget') || 
                   node.querySelector && node.querySelector('.trustpilot-widget'))) {
                hasRelevantChanges = true;
              }
            });
          }
        });
        
        if (hasRelevantChanges) {
          console.log('[Trustpilot Reinit] Detected cloning of Trustpilot widgets, reinitializing...');
          // Wait a brief moment for DOM to settle, then reinitialize
          setTimeout(waitForTrustpilotAndReinit, 100);
        }
      });
      
      observer.observe(surface, {
        childList: true,
        subtree: false // Only watch direct children
      });
    });
    
    return true;
  }
  
  /**
   * Initialize on DOM ready
   */
  function init() {
    console.log('[Trustpilot Reinit] Initializing...');
    
    // Initial reinit for any existing widgets
    setTimeout(waitForTrustpilotAndReinit, 500);
    
    // Set up observers for future cloning
    if (!observeScrollingItems()) {
      // If scrolling items aren't ready yet, try again after a delay
      setTimeout(function() {
        observeScrollingItems();
        // Reinit again after observer is set up
        setTimeout(waitForTrustpilotAndReinit, 500);
      }, 1000);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Also initialize on window load as a backup
  window.addEventListener('load', function() {
    console.log('[Trustpilot Reinit] Window loaded, reinitializing widgets');
    setTimeout(waitForTrustpilotAndReinit, 500);
  });
  
  // Listen for Shopify section changes (in theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      console.log('[Trustpilot Reinit] Shopify section loaded, reinitializing');
      setTimeout(function() {
        observeScrollingItems();
        waitForTrustpilotAndReinit();
      }, 500);
    });
  }
  
})();

